import { Card } from "@blueprintjs/core";
import * as React from "react";
import Question from "~/components/FAQ/Question";
import { IQuestion } from "~/components/FAQ/types";
import { shopConfig } from "~/helpers/shopConfig";
import styled from "~/styled";

interface IProps {
  questions: IQuestion[];
  openQuestionKey: string;
  onQuestionChange: (key: string | null) => void;
}

const QuestionsList = styled.div`
  display: grid;
  grid-row-gap: 6px;
`;

export default class Questions extends React.Component<IProps> {
  public render() {
    const { questions, openQuestionKey } = this.props;

    return (
      <Card>
        <QuestionsList>
          {questions.map(question => {
            if (
              question.key === "bank-transfer" &&
              (shopConfig.organization === "emerchant" ||
                shopConfig.organization === "gecom")
            ) {
              return null;
            }
            return (
              <Question
                key={question.key}
                question={question}
                open={openQuestionKey === question.key}
                onToggle={this.handleToggle(question.key)}
              />
            );
          })}
        </QuestionsList>
      </Card>
    );
  }

  private handleToggle = (key: string) => () =>
    this.props.onQuestionChange(
      this.props.openQuestionKey === key ? null : key
    );
}



// WEBPACK FOOTER //
// ./src/components/FAQ/Questions.tsx